'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { FT_PI_AUTH0_LOGIN } from '@whitbread-eos/api';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { decodeIdToken, getAuthCookie, ID_TOKEN_COOKIE } from '../getters';
import { deleteCookie } from '../helpers';
import { useCustomLocale, useFeatureToggle } from '../hooks';
import noop from '../utils/noop';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UserDataContext = React.createContext({
  isLoggedIn: false,
  setIsLoggedIn: noop
});
export function useUserData() {
  return useContext(UserDataContext);
}
export function UserContextProvider(_ref) {
  var _featureToggles$FT_PI;
  var children = _ref.children,
    authWatcher = _ref.authWatcher;
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country;
  var featureToggles = useFeatureToggle();
  var isAuth0Enabled = (_featureToggles$FT_PI = featureToggles === null || featureToggles === void 0 ? void 0 : featureToggles[FT_PI_AUTH0_LOGIN]) !== null && _featureToggles$FT_PI !== void 0 ? _featureToggles$FT_PI : false;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoggedIn = _useState2[0],
    setIsLoggedIn = _useState2[1];
  var isLoggedInRef = useRef(isLoggedIn);
  useEffect(() => {
    isLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn]);
  var value = useMemo(() => ({
    isLoggedIn,
    setIsLoggedIn
  }), [isLoggedIn]);
  useEffect(() => {
    if (!isAuth0Enabled) {
      var cookie = getAuthCookie();
      var _decodeIdToken = decodeIdToken(cookie),
        email = _decodeIdToken.email;
      setIsLoggedIn(!!(email !== null && email !== void 0 && email.length));
    }
  }, [isAuth0Enabled]);
  useEffect(() => {
    if (isAuth0Enabled) {
      return;
    }
    var intervalId = setInterval(() => {
      var idToken = getAuthCookie();
      if (!idToken) {
        setIsLoggedIn(false);
      }
      if (idToken && !isLoggedInRef.current) {
        var _decodeIdToken2 = decodeIdToken(idToken),
          userEmail = _decodeIdToken2.email;
        if (userEmail !== null && userEmail !== void 0 && userEmail.length) {
          setIsLoggedIn(true);
        }
      } else if (idToken && isLoggedInRef.current) {
        var _decodeIdToken3 = decodeIdToken(idToken),
          expData = _decodeIdToken3.exp;
        var currentTimeInSeconds = new Date().getTime() / 1000;
        if (expData && currentTimeInSeconds > expData) {
          deleteCookie(ID_TOKEN_COOKIE);
        }
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [country, isAuth0Enabled]);
  return _jsxs(UserDataContext.Provider, {
    value: value,
    children: [isAuth0Enabled && (authWatcher === null || authWatcher === void 0 ? void 0 : authWatcher(setIsLoggedIn)), children]
  });
}